import PropTypes from 'prop-types';
import {BadgeBox} from "./style";

function Badge({setText}){
  return <BadgeBox>{setText}</BadgeBox>
}

Badge.propTypes = {
  setText: PropTypes.string
}

Badge.defaultProps = {
  setText: ''
}

export default Badge;